export const guidesData = [
    {
        emoji: '👋',
        title: 'Welcome to Fourthwall',
        guides: [
            {
                title: 'Getting started',
                slug: '/getting-started',
            },
        ],
    },
    {
        emoji: '🎨',
        title: 'Creating products that sell',
        guides: [
            {
                title: 'Creating products that sell',
                slug: '/creating-products-that-sell',
            },
            {
                title: 'Ordering samples',
                slug: '/ordering-samples',
            },
        ],
    },
    {
        emoji: '🚀',
        title: 'Launching successfully',
        guides: [
            {
                title: 'Planning your launch',
                slug: '/planning-your-launch',
            },
            {
                title: 'Your launch checklist',
                slug: '/your-launch-checklist',
            },
            {
                title: 'After your launch',
                slug: '/after-your-launch',
            },
        ],
    },
    {
        emoji: '💸',
        title: 'Setting up for success',
        guides: [
            {
                title: 'Growing your brand',
                slug: '/growing-your-brand',
            },
        ],
    },
];
